import styled from 'styled-components';
import { Container } from '../../../../stories/atoms';
import { IconWithText } from '../../../../stories/molecules';

export const StyledContainer = styled(Container)`
  margin: ${({ theme: { spacing } }) => spacing(0, 4)};
  > div {
    height: auto;
  }
`;

export const StyledIconWithText = styled(IconWithText)`
  > div {
    color: ${({ theme: { color, palette } }) =>
      palette.mode === 'dark' ? color.secondaryDarkTextGray : color.secondaryTextGray};
  }
`;
